import { SORTING_DIRECTION } from 'src/constants/main';

export interface ILanguageTranslationsFilters {
  search: string;
  type: LANGUAGE_TRANSLATIONS_TYPE;
  perPage: number | undefined;
  sortField: LANGUAGE_TRANSLATIONS_SORT_COLUMN;
  sortDir: SORTING_DIRECTION;
}

export enum LANGUAGE_TRANSLATIONS_SORT_COLUMN {
  KEY = 'key',
  AR = 'ar',
  EN = 'en',
}

export enum LANGUAGE_TRANSLATIONS_TYPE {
  BACKEND = 'messages',
  FRONTEND = 'frontend',
  API = 'api',
}

export interface ILanguageTranslationValidation {
  key: IDefaultLanguageTranslationsFieldValidation;
  type: IDefaultLanguageTranslationsFieldValidation;
  translations: {
    en: IDefaultLanguageTranslationsFieldValidation;
    ar: IDefaultLanguageTranslationsFieldValidation;
  };
}

export interface IDefaultLanguageTranslationsFieldValidation {
  state: boolean;
  errorText?: string;
}
